@if (this.news$ | async; as newsSections) {
  <div class="news-feed">
    @for (newsSection of newsSections; track newsSection; let idx = $index) {
      @if (newsSection.date) {
        <section class="news-feed__section">
          <div class="news-feed__date">
            {{ newsSection.date | date:'dd.MM.yyyy' }}
          </div>
          @for (newsItem of newsSection.newsItems; track newsItem; let idx = $index) {
            @if (newsItem.summary) {
              <div
                class="news-feed__text-container">
                <p [innerHTML]="newsItem.summary | safeHtml"
                  class="news-feed__text">
                </p>
              </div>
            }
            @if (newsItem.linkUrl && newsItem.linkName) {
              <a href="{{ newsItem.linkUrl }}"
                class="news-feed__more-cta">
                {{ newsItem.linkName }}
              </a>
            }
          }
        </section>
      }
    }
  </div>
}
